var comp = 'badge';
export var dataHooks = {
  label: "".concat(comp, "-label")
};
export var skins = {
  standard: 'standard',
  premium: 'premium',
  attention: 'attention',
  success: 'success',
  alert: 'alert',
  urgent: 'urgent',
  general: 'general'
};